import React, { useState, useEffect } from "react";
import { useMediaQuery } from "@mui/material";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mhome/ui";

const CanvasSelectDialog = ({
  open,
  onClose,
  onCanvasChange,
  canvasList,
  unavailableCanvasList = [],
  title = "Select Target Canvas",
  isLoading = false,
}) => {
  const [selectedCanvasId, setSelectedCanvasId] = useState(null);
  const isSmallScreen = useMediaQuery("@media (max-width:959px)");

  useEffect(() => {
    if (open) {
      setSelectedCanvasId(null);
    }
  }, [open]);

  const handleClose = () => {
    setSelectedCanvasId(null);
    onClose();
  };

  const handleCanvasSelect = (canvasId) => {
    setSelectedCanvasId(canvasId);
  };

  const handleMove = () => {
    if (selectedCanvasId) {
      onCanvasChange(selectedCanvasId);
      setSelectedCanvasId(null);
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      variant="pops"
      PaperProps={{
        style: {
          width: isSmallScreen ? "calc(100% - 32px)" : "400px",
          minWidth: isSmallScreen ? "280px" : "400px",
          maxWidth: isSmallScreen ? "calc(100% - 32px)" : "500px",
        },
      }}
    >
      <DialogTitle className="pt-4 px-4">{title}</DialogTitle>
      <DialogContent className="pt-4">
        <div className="flex flex-col gap-2">
          {canvasList
            .filter((canvas) => !unavailableCanvasList.includes(canvas.id))
            .map((canvas) => {
              const isSelected = selectedCanvasId === canvas.id;
              return (
                <Button
                  key={canvas.id}
                  variant={isSelected ? "contained" : "outlined"}
                  onClick={() => handleCanvasSelect(canvas.id)}
                  disabled={isLoading}
                  className="justify-start normal-case w-full"
                  style={{
                    minWidth: "100%",
                    textAlign: "left",
                  }}
                >
                  {canvas.name}
                </Button>
              );
            })}
        </div>
      </DialogContent>
      <DialogActions className="gap-2 px-4 pb-4">
        <Button
          onClick={handleClose}
          variant="outlined"
          className="normal-case flex-1"
        >
          Cancel
        </Button>
        <Button
          onClick={handleMove}
          variant="contained"
          disabled={!selectedCanvasId || isLoading}
          className="normal-case flex-1"
        >
          Move
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CanvasSelectDialog;
